import { render, staticRenderFns } from "./CandidatesCustomLabels.vue?vue&type=template&id=9626b598&scoped=true&lang=pug"
import script from "./CandidatesCustomLabels.vue?vue&type=script&lang=js"
export * from "./CandidatesCustomLabels.vue?vue&type=script&lang=js"
import style0 from "./CandidatesCustomLabels.vue?vue&type=style&index=0&id=9626b598&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9626b598",
  null
  
)

export default component.exports